import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

const pinCategory = async (categoryId: string) => {
  const [response, bodyOrError] = await Api.patch(`categories/${categoryId}/pin`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const usePinCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'pinCategory',
    (categoryId: string) => {
      return pinCategory(categoryId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['getCategoriesByPage']);
        queryClient.invalidateQueries(['getSubCategoriesByPage']);
      },
    },
  );
};
